export enum TypLokalizace {
	CZ = 'CS',
	EN = 'EN'
}
